import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import LanguageSwitcher from '../LanguageSwitcher/LanguageSwitcher';
import './Header.css';

const Header = () => {
  const { t } = useTranslation();
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
    setIsMenuOpen(false);
  };

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };


  return (
    <header className={`header ${isScrolled ? 'scrolled' : ''}`}>
      <nav className="nav">
        <div className="nav-section nav-left">
          <div className="nav-brand" onClick={() => scrollToSection('hero')}>
            <div className="brand-logo">
              <img src="/iconcat.png" alt="ApageDev Logo" className="logo-image" />
            </div>
          </div>
        </div>

        <div className="nav-section nav-center">
          <div className={`nav-menu ${isMenuOpen ? 'open' : ''}`}>
             <a href="#vision" onClick={(e) => { e.preventDefault(); scrollToSection('vision'); }} className="nav-link">
               {t('header.vision')}
             </a>
             <a href="#skills" onClick={(e) => { e.preventDefault(); scrollToSection('skills'); }} className="nav-link">
               {t('header.skills')}
             </a>
             <a href="#offerings" onClick={(e) => { e.preventDefault(); scrollToSection('offerings'); }} className="nav-link">
               {t('header.offerings')}
             </a>
             <a href="#projects" onClick={(e) => { e.preventDefault(); scrollToSection('projects'); }} className="nav-link">
               Mythbound
             </a>
             <a href="#contact" onClick={(e) => { e.preventDefault(); scrollToSection('contact'); }} className="nav-link">
               {t('header.contact')}
             </a>
           </div>
        </div>

        <div className="nav-section nav-right">
          <LanguageSwitcher />
          <div className="nav-toggle" onClick={toggleMenu}>
            <span className={`bar ${isMenuOpen ? 'open' : ''}`}></span>
            <span className={`bar ${isMenuOpen ? 'open' : ''}`}></span>
            <span className={`bar ${isMenuOpen ? 'open' : ''}`}></span>
          </div>
        </div>
      </nav>
    </header>
  );
};

export default Header;